import { getCachedViewJobHint } from '../../../shared/native-modules/tare/getCachedViewJobHint';
import { setCachedViewJobHint } from '../../../shared/native-modules/tare/setCachedViewJobHint';

/**
 * Marks a job as disliked in the cached ViewJobHint
 * @param jobKey - The job key to mark as disliked
 * @throws Error if the cache update fails
 */
export async function markJobAsDisliked(
    jobKey: string,
    keepMatchFactor: boolean = false,
): Promise<void> {
    try {
        const hint = await getCachedViewJobHint(jobKey);
        await setCachedViewJobHint(jobKey, {
            isSaved: hint?.isSaved ?? null,
            title: hint?.title ?? null,
            isFromAce: hint?.isFromAce ?? null,
            jobResultTrackingKey: hint?.jobResultTrackingKey ?? null,
            isDisliked: true,
            matchFactor: keepMatchFactor ? (hint?.matchFactor ?? null) : null,
        });
        // TODO emit to DD metrics
    } catch (error) {
        console.error('[markJobAsDisliked] Failed to update cache:', error);
        // TODO emit to DD metrics
    }
}
